/*
 * Browning configurator (sections/browning-configurator.liquid)
 *
 * Same shape as liberty-configurator.js: renders the size / color / hardware / lock / scene / hinge /
 * door-storage pickers from the metaobject data embedded in #brc-data, shows the live price, and tells
 * the Meta Variant Builder checkout block what is selected via `configurator:updated`
 * ({ selections, modelId }; selections keyed by option-group handle: br_size, br_body_color, ...).
 *
 * The hero photo is LAYERED (ported from the safe-configurator block): the best-matching "body" photo
 * for size + color (+ hinge side) with a transparent "composite" hardware overlay, a "scene" door-art
 * overlay and a "lock" overlay stacked on top. Every layer matches on its own axes; an axis left
 * empty on a layer matches anything, and the most specific layer wins.
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('brc-data');
  var root = document.querySelector('.brc');
  if (!dataEl || !root) return;

  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { console.error('[brc] could not parse configurator data', e); return; }

  var G = { size: 'br_size', color: 'br_body_color', hw: 'br_hardware_color', lock: 'br_lock_type', scene: 'br_scene', hinge: 'br_hinge_side', storage: 'br_door_storage' };
  var opts = D.options || {};
  var sizes = D.sizes || [];
  var BASE = D.base || '';
  function abs(u) { return !u ? '' : (u.indexOf('http') === 0 ? u : BASE + u); }
  // row: [role, sizes[], colors[], hardware[], locks[], required[], hingeSwing, image, openImage, sort]
  var layers = (D.layers || []).map(function (r) {
    return { role: r[0], size: r[1], color: r[2], hw: r[3], lock: r[4], req: r[5], hinge: r[6] || null, img: abs(r[7]), open: abs(r[8]), sort: r[9] || 0 };
  });
  var byRole = { body: [], composite: [], scene: [], lock: [] };
  layers.forEach(function (l) { if (byRole[l.role] && l.img) byRole[l.role].push(l); });

  var st = { size: null, color: null, hw: null, lock: null, scene: null, hinge: null, storage: null };
  var view = 'configured'; // 'configured' | 'open'
  var $ = function (id) { return document.getElementById(id); };

  function money(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function sizeCfg(code) { for (var i = 0; i < sizes.length; i++) if (sizes[i].code === code) return sizes[i]; return null; }

  // ---------- option lists ----------
  function optionsFor(group) {
    var cfg = sizeCfg(st.size);
    if (!cfg) return [];
    return cfg.opts.map(function (c) { return opts[c]; })
      .filter(function (o) { return o && o.group === group; })
      .sort(function (a, b) { return (a.so || 0) - (b.so || 0); });
  }
  function pickDefault(list) {
    for (var i = 0; i < list.length; i++) if (list[i].def === true) return list[i].code;
    return list.length ? list[0].code : null;
  }
  function normalize() {
    Object.keys(G).forEach(function (k) {
      if (k === 'size') return;
      var list = optionsFor(G[k]);
      if (!list.length) st[k] = null;
      else if (!list.some(function (o) { return o.code === st[k]; })) st[k] = pickDefault(list);
    });
  }
  function hingeSwing() {
    var o = opts[st.hinge];
    return (o && o.deps && o.deps.hinge_swing) || null;
  }

  // ---------- price ----------
  // default price -> dependencies.price_by_size[size] -> legacy price_modifier_value (same order as the backend pricing engine)
  function optPrice(o) {
    if (!o) return 0;
    if (o.dp > 0) return o.dp;
    var d = o.deps;
    if (d && d.price_by_size && d.price_by_size[st.size] != null && typeof d.price_by_size[st.size] !== 'object') return +d.price_by_size[st.size] || 0;
    if (d && d[st.size] != null && typeof d[st.size] !== 'object') return +d[st.size] || 0;
    return +o.mod || 0;
  }
  function total() {
    var cfg = sizeCfg(st.size);
    var t = cfg ? +cfg.base : 0;
    ['color', 'hw', 'lock', 'scene', 'hinge', 'storage'].forEach(function (k) { var o = opts[st[k]]; if (o) t += optPrice(o); });
    return t;
  }

  // ---------- layer matching (ported from the safe-configurator block) ----------
  function axisOk(list, cur) { return !list || !list.length || (!!cur && list.indexOf(cur) !== -1); }
  function hingeOk(entry, cur) { return !entry || !cur || entry === cur; }
  function best(list, crit, needOpen) {
    var b = null, bs = -1;
    for (var i = 0; i < list.length; i++) {
      var e = list[i];
      if (needOpen && !e.open) continue;
      if (!axisOk(e.size, crit.size) || !axisOk(e.color, crit.color) || !axisOk(e.hw, crit.hw) || !axisOk(e.lock, crit.lock) || !axisOk(e.req, crit.req) || !hingeOk(e.hinge, crit.hinge)) continue;
      var sc = (e.size.length ? 1 : 0) + (e.color.length ? 1 : 0) + (e.hw.length ? 1 : 0) + (e.lock.length ? 1 : 0) + (e.req.length ? 1 : 0) + (e.hinge ? 1 : 0);
      if (sc > bs) { b = e; bs = sc; }
    }
    return b;
  }
  function currentMatches() {
    var hinge = hingeSwing();
    var body = best(byRole.body, { size: st.size, color: st.color, hw: st.hw, lock: st.lock, hinge: hinge });
    var comp = best(byRole.composite, { size: st.size, hw: st.hw, lock: st.lock, hinge: hinge });
    var lockL = byRole.lock.length ? best(byRole.lock, { size: st.size, hw: st.hw, lock: st.lock }) : null;
    var scene = st.scene && byRole.scene.length ? best(byRole.scene, { size: st.size, color: st.color, hw: st.hw, req: st.scene }) : null;
    var open = best(byRole.body, { size: st.size, color: st.color, hinge: hinge }, true);
    return { body: body, comp: comp, lock: lockL, scene: scene, open: open };
  }

  // ---------- rendering ----------
  function priceTag(p) { return '<span class="brc-card-price">' + (p > 0 ? '+' + money(p).replace('.00', '') : '') + '</span>'; }
  var painted = {}, nodeCache = {};
  // Option cards contain <img>; a list is only rebuilt when its SET of options changes, so picking an option never reloads images.
  function paintList(elId, codes, buildOne) {
    var el = $(elId);
    var sig = codes.join('|');
    if (painted[elId] === sig) return el;
    painted[elId] = sig;
    var cache = nodeCache[elId] || (nodeCache[elId] = {});
    var keep = [];
    codes.forEach(function (code) {
      var node = cache[code];
      if (!node) { var tmp = document.createElement('div'); tmp.innerHTML = buildOne(code); node = tmp.firstElementChild; cache[code] = node; }
      keep.push(node);
    });
    Array.prototype.slice.call(el.children).forEach(function (c) { if (keep.indexOf(c) === -1) el.removeChild(c); });
    keep.forEach(function (n) { el.appendChild(n); });
    return el;
  }
  function markActive(el, attr, activeCode, priceOf) {
    var nodes = el.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < nodes.length; i++) {
      var b = nodes[i], code = b.getAttribute(attr), on = code === activeCode;
      if (b.classList.contains('active') !== on) b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var tag = b.querySelector('.brc-card-price');
      if (tag) { var p = priceOf ? priceOf(code) : 0; var txt = p > 0 ? '+' + money(p).replace('.00', '') : ''; if (tag.textContent !== txt) tag.textContent = txt; }
    }
  }
  function shortSize(s) { return (s.label || s.name || '').split(' - ')[0]; }

  function renderSizes() {
    var el = paintList('brc-sizes', sizes.map(function (s) { return s.code; }), function (code) {
      var s = sizeCfg(code);
      return '<button type="button" class="brc-card brc-card--size" data-size="' + esc(s.code) + '">' +
        (s.img ? '<img src="' + esc(s.img) + '" alt="" loading="lazy" width="96" height="96">' : '') +
        '<span class="brc-card-label">' + esc(shortSize(s)) + '</span></button>';
    });
    markActive(el, 'data-size', st.size);
    var cfg = sizeCfg(st.size);
    $('brc-size-label').textContent = cfg ? (cfg.name || cfg.label) : '';
  }
  function renderColors() {
    var list = optionsFor(G.color);
    var el = paintList('brc-colors', list.map(function (o) { return o.code; }), function (code) {
      var o = opts[code];
      var bg = o.img ? 'background-image:url(' + esc(o.img) + ');background-size:cover;background-position:center;' : 'background-color:' + esc(o.hex || '#666') + ';';
      return '<button type="button" class="brc-swatch" data-color="' + esc(o.code) + '" title="' + esc(o.label) + '" aria-label="' + esc(o.label) + '" style="' + bg + '"></button>';
    });
    markActive(el, 'data-color', st.color);
    var cur = opts[st.color], p = optPrice(cur);
    $('brc-color-label').textContent = cur ? cur.label + (p > 0 && list.length > 1 ? ' (+' + money(p).replace('.00', '') + ')' : '') : '';
    $('brc-color-wrap').hidden = list.length === 0;
  }
  function renderCards(key, elId, dataAttr, labelId, wrapId) {
    var list = optionsFor(G[key]);
    var el = paintList(elId, list.map(function (o) { return o.code; }), function (code) {
      var o = opts[code];
      return '<button type="button" class="brc-card' + (o.img ? '' : ' brc-card--text') + '" ' + dataAttr + '="' + esc(o.code) + '"' + (o.tip ? ' title="' + esc(o.tip) + '"' : '') + '>' +
        (o.img ? '<img class="brc-card-img" src="' + esc(o.img) + '" alt="" loading="lazy" width="72" height="72">' : '') +
        '<span class="brc-card-label">' + esc(o.label) + '</span>' + priceTag(0) + '</button>';
    });
    var included = list.length === 1; // a single choice is just part of the safe: don't advertise it as an add-on
    markActive(el, dataAttr, st[key], included ? function () { return 0; } : function (c) { return optPrice(opts[c]); });
    var cur = opts[st[key]], p = included ? 0 : optPrice(cur);
    $(labelId).textContent = cur ? cur.label + (p > 0 ? ' (+' + money(p).replace('.00', '') + ')' : '') : '';
    $(wrapId).hidden = list.length === 0;
  }

  function renderSpecs() {
    var sig = st.size;
    if (painted['brc-specs'] === sig) return;
    painted['brc-specs'] = sig;
    var cfg = sizeCfg(st.size) || {};
    var rows = [];
    var gun = cfg.gun || D.fallbackGun;
    if (gun && String(gun) !== '0') rows.push(['target', 'Up to ' + esc(gun) + ' long guns']);
    if (cfg.weight) rows.push(['weight', esc(cfg.weight) + ' lbs']);
    if (cfg.ext) rows.push(['maximize', 'External: ' + esc(cfg.ext)]);
    if (cfg.int) rows.push(['minimize', 'Internal: ' + esc(cfg.int)]);
    rows.push(['shield-check', 'Limited Life-Time Warranty']);
    $('brc-specs').innerHTML = rows.map(function (r) {
      return '<div class="info-item"><i data-lucide="' + r[0] + '" class="info-icon"></i><span class="info-text">' + r[1] + '</span></div>';
    }).join('');
    if (window.lucide && window.lucide.createIcons) window.lucide.createIcons();
  }
  function renderKeyFeatures() {
    var cfg = sizeCfg(st.size);
    if (!cfg) return;
    function put(id, val) { var el = $(id); if (el && val != null && val !== '' && String(el.textContent) !== String(val)) el.textContent = val; }
    put('kf-gun', parseFloat(cfg.gun) > 0 ? cfg.gun : null);
    put('kf-fire', cfg.fire > 0 ? cfg.fire : null);
    put('kf-security', cfg.sec > 0 ? cfg.sec : null);
  }

  // ---------- layered hero ----------
  var swapToken = 0;
  function preload(url) {
    return new Promise(function (resolve) {
      if (!url) return resolve();
      var im = new Image(); im.onload = im.onerror = function () { resolve(); }; im.src = url;
    });
  }
  function setOv(id, url) {
    var el = $(id);
    if (!el) return;
    if (url) { if (el.getAttribute('src') !== url) el.setAttribute('src', url); el.hidden = false; } else { el.hidden = true; }
  }
  function renderHero() {
    var img = $('brc-hero-img'), toggle = $('brc-open-toggle');
    var m = currentMatches();
    if (!m.body) {
      var fb = D.fallbackImg || '';
      if (fb && img.getAttribute('src') !== fb) img.setAttribute('src', fb);
      setOv('brc-ov-comp', null); setOv('brc-ov-scene', null); setOv('brc-ov-lock', null);
      toggle.hidden = true;
      renderThumbs(null);
      return;
    }
    var hasOpen = !!(m.open && m.open.open);
    if (view === 'open' && !hasOpen) view = 'configured';
    toggle.hidden = !hasOpen;
    toggle.textContent = view === 'open' ? 'View closed' : 'View open';
    var token = ++swapToken;
    var bodyUrl = view === 'open' ? m.open.open : m.body.img;
    var showOverlays = view !== 'open';
    var compUrl = showOverlays && m.comp ? m.comp.img : null, sceneUrl = showOverlays && m.scene ? m.scene.img : null, lockUrl = showOverlays && m.lock ? m.lock.img : null;
    Promise.all([preload(bodyUrl), preload(compUrl), preload(sceneUrl), preload(lockUrl)]).then(function () {
      if (token !== swapToken) return; // superseded by a newer selection while loading
      if (img.getAttribute('src') !== bodyUrl) img.setAttribute('src', bodyUrl);
      setOv('brc-ov-comp', compUrl); setOv('brc-ov-scene', sceneUrl); setOv('brc-ov-lock', lockUrl);
    });
    renderThumbs(m.body);
  }

  // thumbnail rail: every body photo for the current size (and hinge side), like the safe-configurator rail
  function renderThumbs(activeBody) {
    var strip = $('brc-thumbs');
    if (!strip) return;
    var hinge = hingeSwing();
    var pool = byRole.body.filter(function (l) { return axisOk(l.size, st.size); });
    if (hinge && pool.some(function (l) { return !l.hinge; })) {
      var twin = {};
      pool.forEach(function (l) { if (l.hinge === hinge) twin[l.color.join('|')] = true; });
      pool = pool.filter(function (l) { return l.hinge ? l.hinge === hinge : !twin[l.color.join('|')]; });
    } else if (hinge) {
      pool = pool.filter(function (l) { return !l.hinge || l.hinge === hinge; });
    }
    var seen = {}, list = [];
    pool.forEach(function (l) { if (!seen[l.img]) { seen[l.img] = 1; list.push(l); } });
    var sig = st.size + '::' + (hinge || '') + '::' + list.length + '::' + st.hw + '::' + st.lock;
    if (strip.getAttribute('data-sig') !== sig) {
      strip.setAttribute('data-sig', sig);
      strip.innerHTML = list.map(function (l, i) {
        var label = [opts[l.color[0]], opts[l.hw[0]], opts[l.lock[0]]].filter(Boolean).map(function (o) { return o.label; }).join(' / ');
        // the body photos are bare doors: stack the current hardware (composite) and lock on top, like the hero
        var tc = best(byRole.composite, { size: st.size, hw: st.hw, lock: st.lock, hinge: hinge });
        var tl = byRole.lock.length ? best(byRole.lock, { size: st.size, hw: st.hw, lock: st.lock }) : null;
        var ovs = (tc ? '<img class="brc-ov" src="' + esc(tc.img) + '" alt="" loading="lazy">' : '') + (tl ? '<img class="brc-ov" src="' + esc(tl.img) + '" alt="" loading="lazy">' : '');
        return '<button type="button" class="brc-thumb" data-i="' + i + '" title="' + esc(label) + '" aria-label="' + esc(label || 'Photo') + '"><img src="' + esc(l.img) + '" alt="" loading="lazy" width="80" height="80">' + ovs + '</button>';
      }).join('');
      strip._list = list;
    }
    var activeUrl = activeBody ? activeBody.img : null;
    Array.prototype.slice.call(strip.querySelectorAll('.brc-thumb')).forEach(function (el) {
      var l = strip._list && strip._list[+el.getAttribute('data-i')];
      el.classList.toggle('active', !!(l && l.img === activeUrl));
    });
  }

  function emit() {
    var sel = {};
    Object.keys(G).forEach(function (k) { if (st[k]) sel[G[k]] = st[k]; });
    var detail = { selections: sel, modelId: D.modelId };
    window.configuratorState = detail;
    window.dispatchEvent(new CustomEvent('configurator:updated', { detail: detail }));
  }
  function renderPrice() { var t = total(); $('brc-price').textContent = money(t); $('brc-total').textContent = money(t); }

  function renderAll() {
    normalize();
    renderSizes();
    renderSpecs();
    renderKeyFeatures();
    renderColors();
    renderCards('hw', 'brc-hw', 'data-hw', 'brc-hw-label', 'brc-hw-wrap');
    renderCards('lock', 'brc-locks', 'data-lock', 'brc-lock-label', 'brc-lock-wrap');
    renderCards('scene', 'brc-scenes', 'data-scene', 'brc-scene-label', 'brc-scene-wrap');
    renderCards('hinge', 'brc-hinges', 'data-hinge', 'brc-hinge-label', 'brc-hinge-wrap');
    renderCards('storage', 'brc-storage', 'data-storage', 'brc-storage-label', 'brc-storage-wrap');
    renderHero();
    renderPrice();
    emit();
  }

  // ---------- events ----------
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-size],[data-color],[data-hw],[data-lock],[data-scene],[data-hinge],[data-storage],#brc-open-toggle,.brc-thumb');
    if (!t || !root.contains(t)) return;
    if (t.id === 'brc-open-toggle') { view = view === 'open' ? 'configured' : 'open'; renderHero(); return; }
    if (t.classList.contains('brc-thumb')) {
      var strip = $('brc-thumbs'), l = strip && strip._list && strip._list[+t.getAttribute('data-i')];
      if (!l) return;
      if (l.color.length === 1 && optionsFor(G.color).some(function (o) { return o.code === l.color[0]; })) st.color = l.color[0];
      if (l.hw.length === 1 && optionsFor(G.hw).some(function (o) { return o.code === l.hw[0]; })) st.hw = l.hw[0];
      if (l.lock.length === 1 && optionsFor(G.lock).some(function (o) { return o.code === l.lock[0]; })) st.lock = l.lock[0];
      view = 'configured';
      renderAll();
      return;
    }
    if (t.dataset.size) st.size = t.dataset.size;
    else if (t.dataset.color) st.color = t.dataset.color;
    else if (t.dataset.hw) st.hw = t.dataset.hw;
    else if (t.dataset.lock) st.lock = t.dataset.lock;
    else if (t.dataset.scene) st.scene = t.dataset.scene;
    else if (t.dataset.hinge) st.hinge = t.dataset.hinge;
    else if (t.dataset.storage) st.storage = t.dataset.storage;
    view = 'configured';
    renderAll();
  });
  // The checkout block resets the configurator after a successful add-to-cart / bfcache restore
  window.addEventListener('configurator:reset', function () { renderAll(); });

  // ---------- init ----------
  if (!sizes.length) { console.warn('[brc] model has no size configurations'); return; }
  var want = new URLSearchParams(window.location.search).get('size');
  var startSize = sizes.filter(function (s) { return s.code === want; })[0] || sizes[0];
  st.size = startSize.code;
  renderAll();
})();
